<script lang="ts">
  import { CheckIcon, CopyIcon } from "lucide-svelte";

  import { useCopy } from "../system/CopyButton.svelte";

  const { source, page } = $props();
  const { handleCopy, lastPress } = useCopy({
    analyticsEventName: "Markdown Copied",
    pageName: page,
  });
</script>

{#if source}
  <button
    class="btn btn-outlined bg-white/5"
    onclick={() => handleCopy(source)}
    title="Copy page"
  >
    {#if $lastPress !== null}
      <CheckIcon size={14} class="mr-2.5 text-white opacity-80" />
    {:else}
      <CopyIcon size={14} class="mr-2.5 text-white opacity-80" />
    {/if}
    <span class="text-sm text-c-gray-80">Copy page</span>
  </button>
{/if}
